import { useIsDesktop } from '@/_hooks/useBreakpoint';

import React, { useState } from 'react';
import OtpDesktop from './otp.desktop';
import OtpMobile from './otp.mobile';
import customerService from '@/_service/customer.service';
import { IRedux } from '@/_store/types';
import { useSelector } from 'react-redux';
import { useTelegram } from '@/_providers/telegram';
import { track } from '@/_utils/utm';
import { FEATURED_BRANDS } from '@/_utils/Constants';

interface IProps {
  isRegister: boolean;
  phoneNumber: string;
  backToLogin: () => void;
  onSuccess: (data: any) => void;
}

const Auth = ({ isRegister, phoneNumber, backToLogin, onSuccess }: IProps) => {
  const [isError, setError] = useState(false);
  const [isSuccess, setSuccess] = useState(false);

  const isDesktop = useIsDesktop();

  const { tg_chat_id } = useTelegram();
  const { user } = useSelector((state: IRedux) => state.auth);
  const { fcm_token, platform_id } = useSelector(
    (state: IRedux) => state.session,
  );

  const trackRegister = async ({ customer_id }: Record<string, string>) => {
    try {
      await track({
        action_type: 'register',
        customer_id,
        tg_chat_id,
      });
    } catch (error) {
      console.log(error);
    }
  };

  const onSubmit = async (code: string) => {
    try {
      if (isError) setError(false);

      const data: {
        code: string;
        phone: string;
        date_of_birth: string;
        tg_chat_id?: string;
        fcm_token?: string;
      } = {
        code,
        phone: phoneNumber,
        date_of_birth: user?.date_of_birth || '',
      };

      if (tg_chat_id) data['tg_chat_id'] = tg_chat_id;
      if (fcm_token) data['fcm_token'] = fcm_token;

      const response = await customerService[
        isRegister ? 'registerConfirm' : 'loginConfirm'
      ](data, FEATURED_BRANDS.yaponamama, platform_id);

      setSuccess(true);
      if (isRegister) await trackRegister({ customer_id: response?.data?.id });

      setTimeout(() => {
        onSuccess(response?.data);
      }, 1000);
    } catch (error) {
      setError(true);
    }
  };

  return (
    <>
      {isDesktop ? (
        <OtpDesktop
          isError={isError}
          onSubmit={onSubmit}
          isSuccess={isSuccess}
          phoneNumber={phoneNumber}
          backToLogin={backToLogin}
        />
      ) : (
        <OtpMobile
          isError={isError}
          onSubmit={onSubmit}
          isSuccess={isSuccess}
          phoneNumber={phoneNumber}
          backToLogin={backToLogin}
        />
      )}
    </>
  );
};

export default Auth;
